import { useMemo, useLayoutEffect, useRef } from "react";
import { PressableScale } from "pressto";
import { UnistylesRuntime } from "react-native-unistyles";
import { useNavigation, Stack } from "expo-router";
import { CameraList } from "@src/features/cameras";
import { Icon } from "@src/components/Icon";

export default function CameraListScreen() {
  const navigation = useNavigation();
  const theme = UnistylesRuntime.getTheme();
  const sortHandlerRef = useRef<(() => void) | null>(null);

  // Memoize header right component to prevent infinite loops
  const headerRight = useMemo(
    () => (
      <PressableScale
        onPress={() => sortHandlerRef.current?.()}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
        style={{
          paddingHorizontal: 16,
          paddingVertical: 4,
        }}
      >
        <Icon name="swapVertical" size={30} color={theme.colors.icon} />
      </PressableScale>
    ),
    [theme.colors.icon],
  );

  // Configure navigation header
  useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: () => headerRight,
      title: "Cameras",
    });
  }, [navigation, headerRight]);

  return (
    <>
      <Stack.Screen
        options={{
          title: "Cameras",
          headerStyle: {
            backgroundColor: theme.colors.background,
          },
          headerTintColor: theme.colors.text,
          headerBackButtonDisplayMode: "minimal",
        }}
      />
      <CameraList
        onSortHandlerReady={(handler) => {
          sortHandlerRef.current = handler;
        }}
      />
    </>
  );
}
